import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import MediaPlayerProps from './MediaPlayerProps'

import Media from './Media'
import Messages from './Messages'

export default {
    props: MediaPlayerProps,
    mixins: [
        KendoBaseComponent, 
        Media, 
        Messages
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoMediaPlayer(this.widgetOptions)
        if(this.v3) {
            this.ready()
        }
        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMediaPlayer()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/KendoMediaPlayer/KendoMediaPlayerMixin.js